import React from 'react';
import { ActivityIndicator, Platform, SafeAreaView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { WebView } from 'react-native-webview';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { RootStackParamList } from '../../../navigations/RootNavigator';
import { hitSlop } from '../../../utils/shared';
import { mbApplyTransparency, mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import ArrowLeft from '../../../resources/svgComponents/ArrowLeft';
import { textStyles } from '../../../constants/textStyles';

type WebViewScreenProps = NativeStackScreenProps<RootStackParamList, 'WebView'>;

export default function WebViewScreen({ route, navigation }: WebViewScreenProps) {
  const { url, headerColor = '#F35E2E' } = route.params;

  return (
    <SafeAreaView style={styles.container}>
      <View style={[styles.header, { backgroundColor: headerColor }]}>
        <TouchableOpacity
          hitSlop={hitSlop}
          onPress={() => navigation.goBack()}
          style={styles.backButton}
        >
          <ArrowLeft size={24} />
          <Text style={styles.backText}>Back</Text>
        </TouchableOpacity>
      </View>
      <WebView
        source={{ uri: url }}
        style={styles.webview}
        startInLoadingState
        renderLoading={() => (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="large" color={headerColor} />
          </View>
        )}
      />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: mbApplyTransparency('#E0E0E0', 0.5),
    // backgroundColor is set dynamically via inline style
    ...Platform.select({
      android: {
        paddingTop: 40,
        elevation: 4,
      },
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 3,
      },
    }),
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
  },
  backText: mbTextStyles([
    textStyles.normalText,
    {
      fontSize: 18,
      fontWeight: '700',
      color: '#FFF',
      marginLeft: 8,
    },
  ]),
  webview: {
    flex: 1,
  },
  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
  },
});
